const axios = require("axios");

const getAccessToken = (token) => {
     return axios.get(`${process.env.URL_COMFAMA_TOKEN_TRANSV}${token||""}`,
     {
     headers: {
         'Content-Type': 'application/json',
     },
 })
};

module.exports = { getAccessToken };
